var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaceNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C4 4.89543 4.89543 4 6 4H42C43.1046 4 44 4.89543 44 6V42C44 43.1046 43.1046 44 42 44H6C4.89543 44 4 43.1046 4 42V6ZM6 6V42H42V6H6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3945 5.81487C29.785 5.42434 30.4181 5.42434 30.8087 5.81487L42.8087 17.8149C43.1992 18.2054 43.1992 18.8386 42.8087 19.2291C42.4181 19.6196 41.785 19.6196 41.3945 19.2291L29.3945 7.22908C29.0039 6.83856 29.0039 6.20539 29.3945 5.81487Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4999 5.71086C17.8904 5.32034 18.5236 5.32034 18.9141 5.71086L42.9141 29.7109C43.3047 30.1014 43.3047 30.7346 42.9141 31.1251C42.5236 31.5156 41.8904 31.5156 41.4999 31.1251L17.4999 7.12508C17.1094 6.73455 17.1094 6.10139 17.4999 5.71086Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60466 5.60616C5.99519 5.21563 6.62835 5.21563 7.01888 5.60616L42.393 40.9803C42.7836 41.3708 42.7836 42.004 42.393 42.3945C42.0025 42.785 41.3693 42.785 40.9788 42.3945L5.60466 7.02037C5.21414 6.62985 5.21414 5.99668 5.60466 5.60616Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08586 16.8757C5.47639 16.4851 6.10955 16.4851 6.50008 16.8757L30.5001 40.8757C30.8906 41.2662 30.8906 41.8993 30.5001 42.2899C30.1096 42.6804 29.4764 42.6804 29.0859 42.2899L5.08586 18.2899C4.69534 17.8993 4.69534 17.2662 5.08586 16.8757Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19133 28.7709C5.58186 28.3804 6.21502 28.3804 6.60554 28.7709L18.6055 40.7709C18.9961 41.1614 18.9961 41.7946 18.6055 42.1851C18.215 42.5757 17.5819 42.5757 17.1913 42.1851L5.19133 30.1851C4.80081 29.7946 4.80081 29.1614 5.19133 28.7709Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1837 29.3971C42.5742 29.7877 42.5742 30.4208 42.1837 30.8114L30.1837 42.8114C29.7931 43.2019 29.16 43.2019 28.7695 42.8114C28.3789 42.4208 28.3789 41.7877 28.7695 41.3971L40.7695 29.3971C41.16 29.0066 41.7931 29.0066 42.1837 29.3971Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9141 16.8754C43.3047 17.2659 43.3047 17.8991 42.9141 18.2896L18.9141 42.2896C18.5236 42.6801 17.8904 42.6801 17.4999 42.2896C17.1094 41.8991 17.1094 41.2659 17.4999 40.8754L41.4999 16.8754C41.8905 16.4849 42.5236 16.4849 42.9141 16.8754Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.396 5.60538C42.7865 5.9959 42.7865 6.62906 42.396 7.01959L7.02185 42.3937C6.63132 42.7843 5.99816 42.7843 5.60763 42.3937C5.21711 42.0032 5.21711 41.37 5.60763 40.9795L40.9818 5.60538C41.3723 5.21485 42.0055 5.21485 42.396 5.60538Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5001 5.7094C30.8906 6.09992 30.8906 6.73309 30.5001 7.12361L6.50007 31.1236C6.10955 31.5141 5.47639 31.5141 5.08586 31.1236C4.69534 30.7331 4.69534 30.0999 5.08586 29.7094L29.0859 5.7094C29.4764 5.31887 30.1095 5.31887 30.5001 5.7094Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2266 5.18865C19.6172 5.57917 19.6172 6.21233 19.2266 6.60286L7.22664 18.6029C6.83611 18.9934 6.20295 18.9934 5.81242 18.6029C5.4219 18.2123 5.4219 17.5792 5.81242 17.1886L17.8124 5.18865C18.2029 4.79812 18.8361 4.79812 19.2266 5.18865Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaceNv);
export default __webpack_public_path__ + "static/media/Lace_nv.df05741510205b6bfaf6393d42902748.svg";
export { ForwardRef as ReactComponent };